import { Divider } from '@mui/material';
import { BaseUrlTitle } from './styles';
import { useTranslation } from 'react-i18next';
import CustomTextInput from 'components/Forms/CustomTextInput';
import LabelTooltip from 'components/FormFields/LabelTooltip';

const BaseUrlInput = () => {
	const { t } = useTranslation();

  return (
    <>
     <Divider />
			<BaseUrlTitle>{t('Base URL')}</BaseUrlTitle>
			<CustomTextInput
				sx={{ width: '100%', mb: 4 }}
				inputProps={{ type: 'string'}}
				label={
					<LabelTooltip
						value={t('Base URL')}
					/>
				}
				name="baseUrl"
				placeholder="https://www.example.com"
			/>
			<Divider />
    </>
  )
}

export default BaseUrlInput;